var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSadFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84 -344)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#fc8e8e",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(84 344)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -105.246)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(95 462.245)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(108 462.245)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "3px",
    d: "M219.813-99.783a7.013,7.013,0,0,1,7.013-7.013,7.013,7.013,0,0,1,7.013,7.013",
    transform: "translate(-121.326 475.296)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/sad_face.5987a8a0.svg";
export { ForwardRef as ReactComponent };